import { Directive } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';


export const FULL_FORMAT = {
  parse: {
    dateInputFull: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Directive({
  selector: '[appFullYearDateFormat]',
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: FULL_FORMAT},
  ],
})
export class FullYearDateFormatDirective {

  constructor() { }

}
